import { useContext, useEffect, useState } from 'react';

import axios from 'axios';
import { toast } from 'react-toastify';
import { getError } from '../../../../utils';
import 'react-toastify/dist/ReactToastify.css';
import '../css/login.css';

import { Form } from 'react-bootstrap';
import AnimatedInput from './AnimatedInput';

const loginFields = [
  {
    key: 'password',
    name: 'Mật khẩu mới',
    type: 'password',
    icon: 'ti ti-lock',
    required: true,
    errorKey: 'password',
  },
  {
    key: 'confirmPassword',
    name: 'Nhập lại mật khẩu',
    type: 'password',
    icon: 'ti ti-lock-password',
    required: true,
    errorKey: 'confirmPassword',
  },
];

const initialForm = {
  token: '',
  password: '',
  confirmPassword: '',
};

const ChangePass = ({ codeOTP, handlePrev, handleClose }) => {
  const [formData, setFormData] = useState(initialForm);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (codeOTP) {
      setFormData((prev) => ({
        ...prev,
        token: codeOTP,
      }));
    }
  }, [codeOTP]);

  const submitHandler = async (e) => {
    e.preventDefault();

    try {
      const { data } = await axios.post('/reset-password', formData);
      handleClose();
      toast.success(data.message);
    } catch (err) {
      const messages = err.response?.data?.messages;
      if (err.response?.status === 422 && messages) {
        setErrors(messages);
      } else {
        toast.error(getError(err));
      }
    }
  };

  return (
    <section>
      <div className="px-2 ">
        <p className="m-0 ">
          Mã OTP của bạn: <strong>{codeOTP}</strong>
        </p>
        <span className="error-message">
          {errors['token'] && errors['token']}
        </span>
      </div>
      <Form onSubmit={submitHandler} className="modalOverideForm">
        {loginFields.map((field, idx) => (
          <div key={idx} className="mb-4 px-2">
            <AnimatedInput
              field={field}
              value={formData[field.key]}
              onChange={(e) =>
                setFormData({ ...formData, [field.key]: e.target.value })
              }
              error={errors[field.errorKey]}
            />
            {field.key === 'password' && (
              <aside className="note-pass">
                <strong style={{ color: 'var(--red)' }}>Lưu ý: </strong>
                Mật khẩu phải chứa ít nhất 8 ký tự, chữ hoa, chữ thường và số.
              </aside>
            )}
          </div>
        ))}

        <div className="d-flex justify-content-end align-items-center mb-3">
          <button
            className=" btn-info-close"
            style={{ marginRight: '1rem' }}
            onClick={handlePrev}
          >
            Quay lại
          </button>
          <button type="submit" className="btn-edit">
            Lưu lại
          </button>
        </div>
      </Form>
    </section>
  );
};
export default ChangePass;
